import { CodeIcon } from "@heroicons/react/solid";
import React from "react";

export default function Projects() {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-20">
          <CodeIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
          Highlighting API Experience: From Fun Projects to Enterprise-level SaaS
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
          Did you know that acquiring new customers can cost up to <a href="https://www.forbes.com/sites/jiawertz/2018/09/12/dont-spend-5-times-more-attracting-new-customers-nurture-the-existing-ones/?sh=6fa380465a8e" class="text-pink-600 font-bold"> five times more</a> than retaining existing ones? Don't let slow ticket resolution times cause your accounts to fall victim to churn. Hire a customer success manager who possesses the perfect blend of business and technical skills to ensure contract renewals and maintain client retention.

Additionally, as a showcase of my technical skills, please check out the following APIs and SaaS services on my portfolio website. They demonstrate my proficiency in creating scalable and efficient software solutions that can help your client's and business succeed.</p>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Projects.js